export const ActionTypes = {
  TRACK_CARD_EVENT: 'zola/cards/tracking/TRACK_CARD_EVENT',
};

export function trackCardEvent(meta) {
  return {
    type: ActionTypes.TRACK_CARD_EVENT,
    payload: meta
  };
}



// WEBPACK FOOTER //
// ./src/cards/actions/tracking.js